import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const ProfileCompletionWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;

  ${mediaMaxWidth.tablet`
    margin-left: 0;
  `}
`;

export const ProfileCompletionData = styled.div`
  width: 650px;
  background: #402680;
  border-radius: 8px;
  margin: ${(props) =>
    props.marginTop ? "10px 15px 0px 15px" : "0 15px 0px 15px"};
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  display: ${(props) => (props.isIE ? "inline-block" : "flex")};
  padding: 20px;
  flex-direction: column;
  position: relative;

  ${mediaMaxWidth.tablet`
    width: ${(props) => (props.mobileMargins ? "calc(100vw - 20px)" : "100vw")};
    margin: ${(props) =>
      props.noSlides ? "10px 10px 0px 10px;" : "10px 10px 10px 10px"};
  `}

  ${mediaMaxWidth.phone`
    padding: 15px;
  `}

  ${mediaMaxWidth.smallPhone`
    padding: 10px;
  `}
`;

export const Title = styled.div`
  color: #fff;
  font-weight: 600;
  font-size: 1em;
  display: flex;
  flex: 1;
  padding: 0 0 2px 0;
  margin: 1px 0 3px 0;

  ${mediaMaxWidth.phone`
    font-size: 0.9em;
    margin: unset;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 0.8em;
  `}
`;

export const TitleSpan = styled.span`
  margin-right: 5px;
`;

export const CloseButton = styled.button`
  width: 25px;
  height: 25px;
  position: absolute;
  right: 20px;
  top: 10px;
  background: none;
  color: #fff;
  border: none;
  font-size: 1.4em;
  transition: 0.1s ease-in-out;
  &:hover {
    color: #79D9D9;
  }
`;

export const Subtitle = styled.div`
  color: #fff;
  font-size: 1em;
  padding: 2px 0 0 0;
  display: flex;
  flex-flow: row wrap;
  margin: 4px 0;

  strong {
    margin: 0 6px;
  }

  ${mediaMaxWidth.phone`
    font-size: 0.9em;
    margin: unset;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 0.8em;
  `}
`;

export const AddButton = styled.a`
  position: absolute;
  right: 18px;
  top: 47px;
  font-weight: bold;
  color: #fff !important;
  padding: 5px 25px;
  cursor: pointer;
  background: #79D9D9;
  border: 1px solid #79D9D9;
  box-sizing: border-box;
  border-radius: 4px;
  transition: 0.15s ease-in-out;
  width: 85px;

  &:hover {
    background: #79D9D9;
    color: #fff;
  }

  &:focus {
    background: #402680;
    border: 1px solid #fff;
    color: #fff;
    outline: none;
  }
  ${mediaMaxWidth.tablet`
    display: flex;
    position: unset;
    order: 4;
    margin-top: 15px;
    align-self: center;
  `}
`;

export const ProgressWrapper = styled.div`
  height: 10px;
  background-color: #8a66a9;
  border-radius: 5px;
  margin-top: 15px;
  display: flex;
`;

export const Progress = styled.div`
  background-color: #79D9D9;
  width: 0%;
  height: 100%;
  border-radius: 5px;
  transition: width 2s ease-in-out;
  &.active {
    width: ${(props) => (props.progress ? `${props.progress}%` : null)};
  }
`;
